import AxiosInterceptorHearro from '../../AxiosInterceptorHearro';

export default function getSystemMessageFromHearro() {
	return AxiosInterceptorHearro({
		url: '/system-message',
		method: 'get',
	});
}
